export const footerTranslations = {
  pt: {
    rights: "© 2025 Hub Links. Feito com 💜 para criadores.",
    socialsAriaLabel: "Redes sociais",
    logoAlt: "Logo Hub Links"
  },
  en: {
    rights: "© 2025 Hub Links. Made with 💜 for creators.",
    socialsAriaLabel: "Social networks",
    logoAlt: "Hub Links Logo"
  }
};
